import React from 'react'

import Navbar from '../Collections/HomePage/Navbar/Navbar'
import ContactBody from '../Collections/Contact/ContactBody'
import Footer from '../Collections/HomePage/Footer/Footer'

const ContactGroup = () => {
  return (
    <>
        <Navbar/>
        <ContactBody/>
        <Footer/>
    </>
  )
}

export default ContactGroup